<template>
    <div class="ekip-date" data-test="date" :data-testid="name" :data-min="min" :data-max="max">
        <Datepicker
            :id="name"
            :value="value"
            :input-class="{ 'is-invalid':hasError }"
            :highlighted="resolvedHighlighted"
            :disabled-dates="resolvedDisabled"
            :language="language"
            :open-date="resolvedOpenDate"
            format="dd/MM/yyyy"
            bootstrap-styling
            monday-first
            clear-button
            clear-button-icon="ekip-date__clear-icon"
            placeholder="jj/mm/aaaa"
            @input="handleInput"
            data-test="picker"
            ref="picker"
        />
        <input class="d-none" type="date" :name="name" :value="formattedDate">
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import { pad, isValidDate, resetHours, addDays } from '../../util/date';
    import {fr} from 'vuejs-datepicker/dist/locale'
    import Vue from 'vue';

    export default {

        inject: {
            field: {
                default:new Vue()
            }
        },

        props: {
            value: [String, Date],
            name: String,
            hasError: Boolean,
            min: [String, Date],
            max: [String, Date],
            highlighted: Object,
            disabled: Object,
            openDate: [String, Date],
            inclusive: Boolean
        },

        components: {
           Datepicker
        },

        data() {
            return {
                date: this.value ? new Date(this.value) : this.value
            }
        },

        computed: {
            language:()=>fr,
            formattedDate() {
                return this.date ? `${this.date.getFullYear()}-${pad(this.date.getMonth()+1)}-${pad(this.date.getDate())}` : null;
            },
            resolvedDisabled() {
                const minDate = new Date(this.min), maxDate = new Date(this.max);
                return {
                    to: isValidDate(minDate) && resetHours(minDate),
                    from: isValidDate(maxDate) && resetHours(addDays(maxDate, this.inclusive ? 1 : 0)),
                    ...(this.disabled)
                };
            },
            resolvedHighlighted() {
                return {
                    includeDisabled: true,
                    ...(this.highlighted)
                }
            },
            resolvedOpenDate() {
                return isValidDate(this.openDate) ? this.openDate : new Date();
            }
        },

        methods:{
            handleInput(val) {
                this.date = val;
                this.$emit('input', val);
                this.field.$emit('clean');
            }
        },

        mounted() {
            this.$emit('input', this.date);
            this.$refs.picker.$el.querySelector('input').autocomplete ='off';
        }
    }
</script>
